import Base from '@studiometa/js-toolkit';
import { isDev } from '../config';

/**
 * ContactSidePopin class
 */
export default class ContactSidePopin extends Base {
  /**
   * Config
   */
  get config() {
    return {
      name: 'ContactSidePopin',
      log: isDev(),
    };
  }

  /**
   * Mounted
   */
  mounted() {
    if (!this.$refs.container || !this.$refs.open || !this.$refs.close) {
      return;
    }
    this.$refs.open.addEventListener('click', this.open);
    this.$refs.close.addEventListener('click', this.close);
  }

  /**
   * Open
   */
  open() {
    this.$refs.container.classList.remove('m:opacity-0');
    this.$refs.container.classList.add('m:pointer-events-auto');
  }

  /**
   * Close
   */
  close() {
    this.$refs.container.classList.add('m:opacity-0');
    this.$refs.container.classList.remove('m:pointer-events-auto');
  }

  /**
   * Destroyed
   */
  destroyed() {
    if (this.$refs.open) {
      this.$refs.open.removeEventListener('click', this.open);
    }
    if (this.$refs.close) {
      this.$refs.close.removeEventListener('click', this.close);
    }
  }
}
